import { render } from "./TreeTargetLayout.vue?vue&type=template&id=33dec9a8"
import script from "./TreeTargetLayout.vue?vue&type=script&lang=js"
export * from "./TreeTargetLayout.vue?vue&type=script&lang=js"
script.render = render

export default script